import * as actions from './actions'
import { loading, success, failure } from 'utilities/actions'

import type { Organisation } from 'types'

export type State = {
  data: Organisation[];
  errors: any[];
  loading: boolean;
  dataFetched: boolean;
  // Organisation scope the current data was fetched under (see sagas).
  scope: string | null;
};

type Action = {
  type: string;
  data?: Organisation[];
  errors?: any[];
  scope?: string;
};

export const initialState: State = {
  data: [],
  errors: [],
  loading: false,
  dataFetched: false,
  scope: null
}

const reducer = (state: State, action: Action) => {
  if (state === undefined) { state = initialState }
  switch (action.type) {
    case loading(actions.API_ORGANISATIONS_ALL):
      // Drop any previously fetched list so stale (e.g. other-scope) options
      // are never shown while the refetch is in flight.
      return { ...state, loading: true, errors: [], data: [] }
    case success(actions.API_ORGANISATIONS_ALL):
      return { ...state, data: action.data, dataFetched: true, scope: action.scope, loading: false }
    case failure(actions.API_ORGANISATIONS_ALL):
      return { ...state, errors: action.errors, loading: false }
    default:
      return state
  }
}

export default reducer
